import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import {AuthService} from "./service/auth.service";
import {NotificationService} from "./service/notification.service";
import {ToastService} from "./service/toast.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit{
    agentPrimaryColor!:string
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title, private authService: AuthService, private notifService:NotificationService, private alert:ToastService
    ) {
        //
        // const color = this.authService.getUserInfos()?.agency.agent.color
        // // console.log('color',color);color??'#4361ee'
        // document.documentElement.style.setProperty('--user-color-primary','67, 97, 238 ');
        authService.setAgentColors();
        this.agentPrimaryColor = authService.getAgentPrimaryColor()
        this.notifService.requestPermission();
        notifService.initMessagingListener()
        this.notifService.currentMessage.subscribe(msg => {
            if (msg) {
                console.log('Notification reçue : ', msg);
                this.alert.showMessage(msg.notification.body,'info',9000, 'secondary')
            }
        });
        // cdr.markForCheck()
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) route = route.firstChild;
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                switchMap((route) => {
                    return route.data.pipe(
                        map((routeData: any) => {
                            const title = routeData['title'];
                            return { title };
                        }),
                    );
                }),
                tap((data: any) => {
                    let title = data.title;
                    title = (title ? title + ' | ' : '') + 'LENSHUB - Build the FUTURE';
                    this.titleService.setTitle(title);
                }),
            )
            .subscribe();
    }

    ngOnInit() {

    }
}
